import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import baseUrl from "../../../../helper/api";
import axios from "../../../../api/axios";

const initialState = {
  pickups: [],
  isLoading: null,
  status: null,
};

const token = userObj?.token;

export const getPickups = createAsyncThunk(
  "partner/getPickups",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/Order/picks/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data.title);
    }
  }
);

const getPickupsSlice = createSlice({
  name: "getPickups",
  initialState,
  reducers: {},
  extraReducers: {
    [getPickups.pending]: (state, action) => {
      state.status = "pending";
      state.isLoading = true;
    },
    [getPickups.fulfilled]: (state, action) => {
      state.status = "success";
      state.isLoading = false;
      state.pickups = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [getPickups.rejected]: (state, action) => {
      state.status = "failed";
      state.isLoading = false;
    },
  },
});

export default getPickupsSlice.reducer;
